<template>
  <div class="c-post">
    <div class="c-msg" v-html="formatMsg(post.content.main)"></div>
    <div class="c-post-btn-space"></div>
    <post-button
      ref="btn"
      :initPost="post"
      :title="isAnswered ? $T('post.btn.confirmed') : isExpired ? $T('common.expired') : $T('post.btn.confirm')"
      :disabled="isGuest || isCompleted"
      @click="onClicked"
    />
  </div>
</template>

<script>
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { answerPostNews } from '../../api/post';

export default {
  mixins: [postDetailPlugin],
  methods: {
    onClicked() {
      if (this.isGuest) return;

      var data = new FormData();
      data.append('pid', this.post.id);

      this.startLoading();
      var self = this;
      answerPostNews(data)
        .then(function(post) {
          self.$emit('modified', post);
          self.stopLoading();
        })
        .catch(function(e) {
          console.error('failed to answer post data for pid[' + self.post.id + ']', e);
          self.errRegisterData();
          self.stopLoading();
        });
    },
  },
};
</script>
